import { format } from 'date-fns';

const getDateLocale = (locale) => (locale === 'sv' ? 'sv' : 'en-AU');

export const showFullDate = (
  date,
  locale,
  settings = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }
) => {
  if (!date) return '';

  if (typeof date === 'string') {
    date = new Date(date);
  }

  return date?.toLocaleString(getDateLocale(locale), settings);
};

export const showShortDate = (
  date,
  locale,
  settings = {
    day: 'numeric',
    month: 'short',
  }
) => {
  if (!date) return '';

  if (typeof date === 'string') {
    date = new Date(date);
  }

  return date?.toLocaleString(getDateLocale(locale), settings);
};

const getDates = (dateRange) => {
  let startDate = '';
  let endDate = '';

  if (typeof dateRange.startDate === 'string') {
    startDate = new Date(dateRange.startDate);
  } else if (dateRange.startDate) {
    startDate = dateRange.startDate;
  }

  if (typeof dateRange.endDate === 'string') {
    endDate = new Date(dateRange.endDate);
  } else if (dateRange.endDate) {
    endDate = dateRange.endDate;
  }

  return { startDate, endDate };
};

export const showDateRange = (
  dateRange,
  locale,
  settings = {
    day: 'numeric',
    month: 'short',
  }
) => {
  if (!dateRange.startDate || !dateRange.endDate) return '';

  const { startDate, endDate } = getDates(dateRange);

  const dateLocale = getDateLocale(locale);

  const formattedEndDate = endDate.toLocaleString(dateLocale, settings);
  if (startDate.getMonth() !== endDate.getMonth()) {
    return `${startDate.toLocaleString(
      dateLocale,
      settings
    )}-${formattedEndDate}`;
  }

  return `${startDate.getDate()}-${formattedEndDate}`;
};

export const showShortsDateRange = (dateRange) => {
  if (!dateRange.startDate || !dateRange.endDate) return '';

  const { startDate, endDate } = getDates(dateRange);

  if (format(startDate, 'yyyyMMM') === format(endDate, 'yyyyMMM')) {
    return `${format(startDate, 'MMM dd')} - ${format(endDate, 'dd')}`;
  }

  return `${format(startDate, 'MMM dd')} - ${format(endDate, 'MMM dd')}`;
};
